<template>
  <div class="cart-result" :class="openedModal">
    <div class="cart-result__content">
      <div class="cart-result__top">
        <div class="cart-result__title texts texts_heading-15">
          Ваш заказ
        </div>
        <a v-if="page === '2'" href="/cart" class="cart-result__change">
          Изменить
        </a>
      </div>

      <div v-if="page === '2'" class="cart-result__products">
        <div class="cart-result__item" v-for="item in checkout.items">
          <div class="cart-result__image-wrap">
            <img :src="item.imagePath"
                 :alt="item.name"
                 class="cart-result__image"
                 v-if="item.imagePath"
            >
            <img src="/static/images/base/noimage.png"
                 alt="no-image"
                 class="cart-result__image"
                 v-else
            >
          </div>

          <div class="cart-result__item-info">
            <div class="cart-result__item-name texts texts_text-12">
              {{ item.name }}
            </div>
            <div class="cart-result__count texts texts_text-12">
                {{ item.quantity }} шт. x {{ formatPrice(item.item_price) }} ₽
            </div>
          </div>
        </div>
      </div>

      <div class="cart-result__info-list">
        <div class="cart-result__cart-price cart-result__info">
          <span class="cart-result__info-key">Сумма заказа</span>
          <span class="cart-result__dots"></span>
          <span class="cart-result__info-value">{{ formatPrice(itemsPrice) }} ₽</span>
        </div>

        <div v-if="page === '2'" class="cart-result__cart-price cart-result__info">
          <span class="cart-result__info-key">Доставка</span>
          <span class="cart-result__dots"></span>
          <span v-if="deliveryPrice > 0" class="cart-result__info-value">{{ formatPrice(deliveryPrice) }} ₽</span>
          <span v-else class="cart-result__info-value">Рассчитает менеджер</span>
        </div>

        <div v-if="page === '2'" class="cart-result__cart-total cart-result__info">
          <span class="cart-result__info-key">Итого</span>
          <span class="cart-result__info-value texts texts_price-small">{{ formatPrice(totalPrice) }} ₽</span>
        </div>
      </div>

      <button type="button"
              v-if="page === '1'"
              class="cart-result__button button button__more button_border button_rotate"
              @click="openFastOrder"
      >
        <span class="button__text-container texts texts_button">
          <span class="button__text">
              Купить в 1 клик
          </span>
          <span class="button__text button__text_clone">
              Купить в 1 клик
          </span>
      </span>
      </button>

      <div class="cart-result__help-wrap">
        <a href="/request/recall-modal"
           class="cart-result__help-button button button_help button_line"
           data-modal
        >
        <span class="button__icon">
          <HelpIcon/>
        </span>
          <span class="button__line-text">
            Нужна помощь с заказом
        </span>
        </a>
      </div>
    </div>

    <popup
        :opened="isModalOpened('fast_order')"
        :is-processing="isProcessing('fast_order')"
        @close="closeModal('fast_order')"
    >
      <TheCartOrderFast/>
    </popup>
  </div>
</template>

<script>
import QuestionIcon from "../icons/QuestionIcon.vue";
import {mapActions, mapGetters, mapState} from "vuex";

import Popup from '../common/Popup.vue';
import modalMixin from '../../mixins/modal';
import TheCartOrderFast from "./TheCartOrderFast.vue";
import HelpIcon from "../icons/HelpIcon.vue";
import element from "../../../components/accordion/objects/element";
import deliveryIcon from "../icons/DeliveryIcon.vue";

export default {
  name: "TheCartResult",
  components: {
    HelpIcon,
    Popup,
    TheCartOrderFast,
    QuestionIcon,
    // Popup
  },
  props: {
    page: String,
  },
  computed: {
    ...mapState('cart', {
      'checkout': 'checkout',
    }),
    ...mapGetters('cart', {
      'totalCount': 'totalCount',
      'total': 'total',
      'deliveryPrice': 'deliveryPrice',
      'itemsPrice': 'itemsPrice',
    }),
    ...mapGetters('order', {
      'isDelivery': 'isDelivery',
    }),
    totalPrice() {
      let total = this.itemsPrice;
      total += this.deliveryPrice

      return total;
    },
    openedModal() {
      return this.isModalOpened('fast_order') ? '_opened' : '';
    }
  },
  methods: {
    formatPrice: function(rawValue) {
      const value = parseInt(rawValue, 10);
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    openFastOrder() {
      this.openModal('fast_order');
    }
  },
  mixins: [
    modalMixin,
  ],
}
</script>